// extracted by mini-css-extract-plugin
module.exports = {"applicationInfo":"AccountPage_applicationInfo__2-IXW","modalWidth":"AccountPage_modalWidth__68wo5","modalButton":"AccountPage_modalButton__2BPth"};